import { render, staticRenderFns } from "./UploadRecordedLectureInBackgroundModal.vue?vue&type=template&id=1008cf25&"
import script from "./UploadRecordedLectureInBackgroundModal.vue?vue&type=script&lang=js&"
export * from "./UploadRecordedLectureInBackgroundModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadRecordedLectureInBackgroundModal.vue?vue&type=style&index=0&id=1008cf25&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports